import { BlackLogo, WhiteLogo } from "assets/img";
import { IconQuestionMark } from "assets/img/icons";
import GoogleTranslate from "components/widgets/WidgetBuilder/GoogleTranslate";
import UploadLimitTerms from "components/widgets/WidgetBuilder/UploadLimitTerms";
import { AppServer } from "config";
import { KEYBOARD, URL } from "constants/common";
import THEME from "constants/themes";
import { WidgetDetailTypes } from "models/Widget";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import utils from "services/utils";
import { StyledIcon, StyledText, StyledWrapper } from "styled-components/Common/CommonStyled";
import { StyledWidgetLogoWrapper } from "styled-components/DynamicWidget/DynamicWidgetStyled";
import {
	StyledLink,
	StyledLogoFooter,
	StyledUploadTerms,
} from "styled-components/WidgetBuilder/WidgetBuilderStyled";

type WidgetFooterSectionProps = {
	widgetDetails: WidgetDetailTypes;
};

const WidgetFooterSection = (props: WidgetFooterSectionProps) => {
	const { t } = useTranslation();
	const { widgetDetails } = props;
	const { metadata: { body, colors } = {} } = widgetDetails || {};
	const { advancedSettings: { enableTranslateButton = false } = {} } = body || {};
	const { highlight = "" } = colors || {};
	const { clientDetail: { settingsDTO: { whiteLabeling = false } = {} } = {} } = useSelector(
		(state: any) => state.widgets,
	);
	const isMobile = utils.isMobileWidth();
	const [isUploadLimitTerms, setIsUploadLimitTerms] = useState<boolean>(false);

	const handleUploadLimitTerms = () => {
		setIsUploadLimitTerms(!isUploadLimitTerms);
	};

	const propsFQAs = {
		i18nKey: "widget_builder.FAQs",
		components: {
			linkTo: (
				<StyledLink
					fontSize="12px"
					target="_blank"
					color={THEME.colors.darkBlue1}
					onClick={handleUploadLimitTerms}
				/>
			),
		},
	};

	const renderLogo = () => {
		return whiteLabeling ? (
			<StyledWidgetLogoWrapper margin="16px 0 0 0" className={isMobile ? "" : "dark-wrapper"}>
				<StyledLink underline="none" href={AppServer} target="_blank" rel="noopener noreferrer">
					<StyledText
						fontSize="12px"
						color={isMobile ? THEME.colors.darkBlue1 : THEME.colors.white}>
						<i>{t("widget_builder.footer.powered_by")}</i>
						<StyledLogoFooter
							src={isMobile ? BlackLogo : WhiteLogo}
							alt={t("widget_builder.entribe_logo")}
						/>
					</StyledText>
				</StyledLink>
			</StyledWidgetLogoWrapper>
		) : (
			<></>
		);
	};

	return (
		<>
			{isMobile ? (
				<StyledWrapper
					margin="64px 0 0 0"
					background="rgba(224, 227, 229, 0.20)"
					padding="16px"
					textAlign="center"
					borderRadius="12px"
					position="relative">
					{enableTranslateButton && (
						<StyledWrapper margin="0 auto 16px auto" width="200px">
							<GoogleTranslate margin="0" isNewLayout={true} />
						</StyledWrapper>
					)}

					<StyledText fontSize="12px" color={THEME.colors.darkBlue1} fontWeight="700">
						{t("widget_builder.having_trouble")}
					</StyledText>
					<StyledText margin="4px 0 8px 0" align="center" fontSize="12px">
						<Trans t={t} {...propsFQAs} />
					</StyledText>

					{renderLogo()}
				</StyledWrapper>
			) : (
				<>
					<StyledUploadTerms className="new-layout" isMobile={isMobile}>
						<StyledIcon
							size={isMobile ? 32 : undefined}
							tabIndex={0}
							onClick={handleUploadLimitTerms}
							colorPath={highlight}
							onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
								utils.onKeyDown(e, handleUploadLimitTerms, KEYBOARD.ENTER.STR);
							}}
							cursor="pointer">
							<IconQuestionMark />
						</StyledIcon>
					</StyledUploadTerms>
					{enableTranslateButton && (
						<StyledWrapper margin="32px auto 16px auto" width="50%">
							<GoogleTranslate margin="0" isNewLayout={true} />
						</StyledWrapper>
					)}
					<StyledWrapper position="fixed" bottom="16px" left="16px">
						{renderLogo()}
					</StyledWrapper>
				</>
			)}

			{isUploadLimitTerms && (
				<UploadLimitTerms
					widgetDetail={widgetDetails}
					onClose={handleUploadLimitTerms}
					isMobile={isMobile}
					isNewLayout={true}
				/>
			)}
		</>
	);
};

export default WidgetFooterSection;
